import { useMemo, useState } from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const iso = (d) => d.toISOString().slice(0, 10);
const monthsAgo = (n) => {
  const d = new Date();
  d.setMonth(d.getMonth() - n);
  return iso(d);
};

export const RANGE_OPTIONS = [
  { value: "all", label: "All Time" },
  { value: "monthly", label: "Last Month" },
  { value: "quarterly", label: "Last Quarter (3 mo)" },
  { value: "half", label: "Last 6 Months" },
  { value: "yearly", label: "Last Year" },
  { value: "ytd", label: "Year to Date" },
  { value: "custom", label: "Custom Range" },
];

export function useDateRange(testPrefix = "range", defaultRange = "all") {
  const [range, setRange] = useState(defaultRange);
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");

  const handleRangeChange = (val) => {
    if (val === "custom" && !customStart && !customEnd) {
      setCustomStart(monthsAgo(1));
      setCustomEnd(iso(new Date()));
    }
    setRange(val);
  };

  const params = useMemo(() => {
    const end = iso(new Date());
    switch (range) {
      case "monthly": return { start: monthsAgo(1), end };
      case "quarterly": return { start: monthsAgo(3), end };
      case "half": return { start: monthsAgo(6), end };
      case "yearly": return { start: monthsAgo(12), end };
      case "ytd": return { start: `${new Date().getFullYear()}-01-01`, end };
      case "custom": return customStart && customEnd ? { start: customStart, end: customEnd } : {};
      default: return {};
    }
  }, [range, customStart, customEnd]);

  const controls = (
    <div className="flex items-end gap-3 flex-wrap">
      <div className="w-52">
        <Select value={range} onValueChange={handleRangeChange}>
          <SelectTrigger data-testid={`${testPrefix}-select`}><SelectValue /></SelectTrigger>
          <SelectContent>
            {RANGE_OPTIONS.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {range === "custom" && (
        <>
          <Input type="date" value={customStart} onChange={(e) => setCustomStart(e.target.value)} className="w-40" data-testid={`${testPrefix}-custom-start`} />
          <Input type="date" value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} className="w-40" data-testid={`${testPrefix}-custom-end`} />
        </>
      )}
    </div>
  );

  return { params, controls };
}
